/* template */
<template><mpx-view @scroll="handleScroll" class="package-list"><div><div v-if="(packUsageList?.length)"><packageUsageItem v-for="(item, index) in (packUsageList)" :key="item.index" :packageUsageItem="(item)"/></div><div class="empty" v-else-if="(!isRequest && !packUsageList?.length)"><mpx-image src="https://ut-static.udache.com/webx/sfc/JWOpy8-v4rb8eAomah41o.png" class="empty-pic"/><div class="empty-text">暂无使用明细</div></div><Loading v-if="(isRequest)"/></div></mpx-view></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"m0aa0f277"}'>
  .package-list
    padding 15px
    overflow-y auto
    .empty
      display flex
      align-items center
      flex-direction column
      padding-top 128px
      &-pic
        height 100px
        width 100px
        margin-bottom 16px
      &-text
        font-family PingFangSC-Regular
        font-weight 400
        font-size 13px
        line-height 13px
        letter-spacing 0px
        color #999999
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m0aa0f277"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./package-usage-list.mpx.js?isComponent&outputPath=components%2Fpackage-usage-list0aa0f277%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./package-usage-list.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fpackage-usage-list0aa0f277%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m0aa0f277"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/package-usage-list0aa0f277/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'packageUsageItem':getComponent(require("./package-usage-item.mpx?isComponent&outputPath=components%2Fpackage-usage-item009b7a6c%2Findex")),'Loading':getComponent(require("../loading.mpx?isComponent&outputPath=components%2Floadingba41c4a6%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
